import React from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useGetInvoicesHandler } from '../../resources/Invoices/dataHandlers/getInvoicesHandler';
import useDocumentFilters from '../filters/DocumentFilterHelper';
import { currencyFormatter } from '../../utils/currencyFormat';
import { formatDate } from '../../utils/formatDate';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const InvoiceSelect = ({ name, onSelect, isPurchase = false }) => {
  const { currentQuery, handleSearchChange, handleSearchKeyPress } = useDocumentFilters({
    defaultQuery: {
      status: 'APPROVED',
    },
    searchOnChange: true,
  });
  const { common } = useTranslatedMessages();
  const invoice_select = common.invoice_select ?? {};
  const { invoices, isLoading } = useGetInvoicesHandler({ searchQuery: currentQuery, isPurchase });

  return (
    <Autocomplete
      id={name}
      options={invoices}
      loading={isLoading}
      getOptionLabel={(option) => {
        const amount = option.payable_amount ?? 0;
        const formattedAmount =
          option.document_currency_code === 'AED'
            ? `AED ${currencyFormatter().format(amount)}`
            : currencyFormatter(option.document_currency_code).format(amount);
        const formattedDate = option.issue_date ? formatDate(option.issue_date) : '';
        return `${option.document_number || '-'} | ${formattedDate} | ${formattedAmount} | ${option.buyer?.name ?? option.accounting_customer_party?.name ?? '-'}`;
      }}
      getOptionKey={(option) => option?._id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={invoice_select.label}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      onChange={(_, value) => onSelect(value)}
      onInputChange={(event, value, reason) => {
        if (reason === 'input') {
          handleSearchChange(event);
        }
      }}
      onKeyDown={handleSearchKeyPress}
      filterOptions={(x) => x}
    />
  );
};

export default InvoiceSelect;
